import Image from 'next/image';
import { useRouter } from 'next/router';
import styled from 'styled-components';
interface containerProps {
  locale: string | undefined;
}
const NawyLoadingIndicator = () => {
  const { locale } = useRouter();

  return (
    <Container locale={locale}>
      <div className="loading">
        <Image
          src="/assets/icons/common/nawy.svg"
          alt="my gif"
          width={150}
          height={40}
          priority
        />

        <progress className="linear-progress" />
      </div>
    </Container>
  );
};

const Container = styled.div<containerProps>`
  position: absolute;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: fit-content;
  height: fit-content;

  .loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: relative;

    .linear-progress {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: none;
      height: 0.25em;
      color: ${props => props.theme.light.colors.primaryBlue};
      background-color: rgba(
        var(--pure-material-primary-rgb, 33, 150, 243),
        0.12
      );
      font-size: 16px;
    }

    .linear-progress::-webkit-progress-bar {
      background-color: transparent;
    }

    /* Determinate */
    .linear-progress::-webkit-progress-value {
      background-color: currentColor;
      transition: all 0.2s;
    }

    .linear-progress::-moz-progress-bar {
      background-color: currentColor;
      transition: all 0.2s;
    }

    .linear-progress::-ms-fill {
      border: none;
      background-color: currentColor;
      transition: all 0.2s;
    }

    /* Indeterminate */
    .linear-progress:indeterminate {
      background-size: 200% 100%;
      background-image: linear-gradient(
        to right,
        transparent 50%,
        currentColor 50%,
        currentColor 60%,
        transparent 60%,
        transparent 71.5%,
        currentColor 71.5%,
        currentColor 84%,
        transparent 84%
      );
      animation: linear-progress 2s infinite linear;
    }

    .linear-progress:indeterminate::-moz-progress-bar {
      background-color: transparent;
    }

    .linear-progress:indeterminate::-ms-fill {
      animation-name: none;
    }

    @keyframes linear-progress {
      0% {
        background-size: 200% 100%;
        background-position: left -31.25% top 0%;
      }
      50% {
        background-size: 800% 100%;
        background-position: left -49% top 0%;
      }
      100% {
        background-size: 400% 100%;
        background-position: left -102% top 0%;
      }
    }
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    scale: 0.8;
  }
`;

export default NawyLoadingIndicator;
